<div class="project_completion_slider_container">
  <div class="backdrop" *ngIf="showSlider()"></div>

  <div class="slide-panel" *ngIf="showSlider()">
    <!-- Simple Header -->
    <div class="modal-container">
        <div class="modal-header">
        <div class="header-content">
          <h2 class="modal-title">Project Completion</h2>
        </div>
        <button (click)="onClose()" class="close-button" aria-label="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="modal-content">
        <h3>
          <mat-icon>schedule</mat-icon>
          Projected Completion Date:
          <span *ngIf="currentProjectedDate(); else noDate">
            {{ currentProjectedDate() | date:'MMM d, yyyy' }}
          </span>
          <ng-template #noDate>
            <span class="no-date">Not set</span>
          </ng-template>
        </h3>

        <form [formGroup]="completionForm" class="completion-form">
          <div
            class="form-group"
            [class.has-error]="completionForm.get('responsibleTeam')?.invalid && completionForm.get('responsibleTeam')?.touched"
          >
            <label class="form-label">Delay Responsibility*</label>
            <div class="responsibility-select-wrapper" [class.has-error]="completionForm.get('responsibleTeam')?.invalid && completionForm.get('responsibleTeam')?.touched">
              <ng-select
                [items]="responsibilities()"
                bindLabel="name"
                bindValue="id"
                [placeholder]="'Select responsible team'"
                [searchable]="true"
                [clearable]="false"
                formControlName="responsibleTeam"
                class="responsibility-select"
                [class.ng-invalid]="completionForm.get('responsibleTeam')?.invalid && completionForm.get('responsibleTeam')?.touched"
                [class.ng-touched]="completionForm.get('responsibleTeam')?.touched"
                required
              >
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div class="team-option">
                    <span class="team-name">{{item.name}}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <mat-error
              *ngIf="completionForm.get('responsibleTeam')?.invalid && completionForm.get('responsibleTeam')?.touched"
            >
              <span>Please select the team responsible for the delay</span>
            </mat-error>
          </div>

          <div
            class="form-group"
          >
            <label class="form-label">New Projected Completion Date*</label>
            <div class="date-picker-wrapper">
                <input
                  matInput
                  [matDatepicker]="picker"
                  formControlName="completionDate"
                  [min]="minDate"
                  [max]="maxDate"
                  placeholder="Select Date"
                  readonly
                  (click)="picker.open()"
                  (blur)="onDateInputBlur()"
                  (focus)="onDateInputFocus()"
                  class="date-picker-input"
                  #dateInput
                  
                />
              <mat-datepicker-toggle matSuffix [for]="picker" class="date-picker-toggle">
                  <i matDatepickerToggleIcon class="wl_icon_calendar"></i>
                </mat-datepicker-toggle>
                <mat-datepicker
                  #picker
                  (closed)="onDatePickerClosed()"
                  (dateChange)="onDateSelected($event)" 
                ></mat-datepicker>
              </div>
              <!-- <mat-error
                *ngIf="completionForm.get('completionDate')?.invalid && completionForm.get('completionDate')?.touched"
              >
                <span>Completion date is required</span>
              </mat-error> -->
          </div>

          <div
            class="form-group"
            [class.has-error]="completionForm.get('notes')?.invalid && completionForm.get('notes')?.touched"
          >
            <label class="form-label"
              >Reason for changing Projected Completion Date? *</label
            >
            <div
              appearance="outline"
              class="w-100"
              [class.mat-form-field-invalid]="completionForm.get('notes')?.invalid && completionForm.get('notes')?.touched"
            >
              <textarea
                matInput
                formControlName="notes"
                placeholder="Type your reason here..."
                rows="3"
                required
              >
              </textarea>
            </div>
            <mat-error class="mat-error-reason"

              *ngIf="completionForm.get('notes')?.invalid && completionForm.get('notes')?.touched"
            >
              <span >Please enter a reason</span>
            </mat-error>
          </div>
        </form>
      </div>

      <div class="modal-actions">
        <button
          (click)="onSave()"
          [disabled]="!completionForm.valid || isLoading()"
          class="btn-save"
        >
          <app-spinner *ngIf="isLoading()" [size]="20"></app-spinner>
          <span *ngIf="!isLoading()">Save</span>
        </button>
        <button
          (click)="onCancel()"
          [disabled]="isLoading()"
          class="btn-cancel"
        >
          <span>Cancel</span>
        </button>
      </div>
    </div>
  </div>
</div>
